<template>
  <div class="container">
    <div class="header">
      <div class="header_content">
        <div style="display: flex; align-items: center;font-weight: bold;">
          {{ $t("jiaren") }}
        </div>
      </div>
    </div>
    <div style="height:13vw"></div>
    <!-- <div style="height: 160px;" v-if="banners.length > 0">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image class="banner_img" :src="$imgSrc(v.url)" width="100%" height="160px">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div> -->
    <div>
      <!-- <div class="title">
        {{ $t("rb") }}
      </div> -->
      <div class="tab-scroll-wrap">
        <div ref="scrollBox" class="tab-scroll">
          <div v-for="(item, idx) in tabList" :key="idx" class="tab-item" :class="{ active: activeIdx === idx }"
            @click="switchTab(item,idx)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" :finished-text="$t('没有更多了')" :loading-text="$t('加载中')"
        :error-text="$t('没有更多了')" @load="onLoad">
        <div style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                flex-wrap: wrap;
                padding: 10px;
              ">
          <div class="gdgride" v-for="item in datalist" :key="item.id">
            <div class="van-image">
              <img :src="$imgSrc(item.img_url)" class="van-image__img" style="object-fit: cover;" />
            </div>
            <span class="icon"><i>{{ $t("index.airborne") }}</i></span>
            <div class="t-box">
              <!-- <div class="p">
                <span style="font-size: 16px;margin-bottom: 5px;">{{ id == 1 ? $t('plnh') : id == 2 ? $t('ssnh') : '' }}</span>
              </div> -->

              <div class="p">
                <div class="left">
                  <img class="quan" :src="$imgSrc(item.img_url)"/>
                  <span style="color:#222;font-size: 12px;">
                    {{ item.xuanfei_name }}
                  </span>
                </div>
                <div class="right">
                  <i class="iconfont icon-dizhi1"></i>
                  <span style="font-size: 14px;">{{ item.class_name }}</span>
                </div>
                
              </div>
              <div class="p">
                <van-rate
                  v-model="rateValue"
                  :size="18"
                  color="#ffd21e"
                  void-icon="star"
                  void-color="#eee"
                />
              </div>
              <div class="p">
                <a class="btns"  @click="toDetail(item.id)">
                  <span>{{ $t('index.instant_booking') }}</span>
                  <i class="iconfont icon-youjiantou1"></i>
                </a>
              </div>
            </div>
            <div class="zan">
                  <img src="/img/aixin.png" class="aixin" style="object-fit: cover;" />
            </div>
            <!-- <div class="address-box">
              <div class="address">
                <i class="dingwei"></i>
                <span>{{ item.address }}</span>
              </div>
              <a class="btn">
                {{ $t("index.instant_booking") }}
              </a>
            </div> -->
          </div>
        </div>
      </van-list>

    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rateValue:5,
      activeIdx: 0,
      tabList: [],
      list: [],
      loading: false,
      finished: false,
      page: 1,
      id: 0,
      translateY: -18,
      containerHeight: 0,
      hasToken: false,
      datalist: [],
      groupedData: [],
      banners: [],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning'],
    };
  },
  methods: {
    switchTab(items, index) {
      this.activeIdx = index
      this.id = items.id
      this.page = 1
      this.onLoad()
      this.$nextTick(() => {
        const container = this.$refs.scrollBox
        const target = container.children[index]
        if (!target) return

        const containerWidth = container.offsetWidth
        const itemLeft = target.offsetLeft
        const itemWidth = target.offsetWidth

        // 计算滚动位置，让当前tab居中
        const scrollLeft = itemLeft - containerWidth / 2 + itemWidth / 2

        container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        })
      })
    },
    onLoad() {
      // 异步更新数据
      this.loading = true
      if (this.page === 1) {
        this.datalist = []
      }
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.id, page: this.page, 'home_class': 2 },
      }).then((res) => {
        console.log(res.data, '11')
        if (res.data.length > 0) {
          res.data.forEach(i => {
            this.datalist.push(i)
          });

        }
        this.loading = false;
        this.finished = true
        //   this.page ++
        //   if (res.data.length < 10) {
        //     this.finished = true;
        //   }
        //   const chunkSize = 2;
        //   this.groupedData = this.datalist.reduce((acc, item, index) => {
        //     if (index % chunkSize === 0) acc.push([]);
        //     acc[Math.floor(index / chunkSize)].push(item);
        //     return acc;
        //   }, []);
        //   console.log(this.groupedData);
      });
    },
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        // console.log('res->',res)
        this.tabList = [{name:this.$t('index.all'),id:0},...res.data[0],...res.data[1]]
        // console.log('this.tabList',this.tabList)
      });
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.banners = res.data.banners;
        console.log(this.banners, 'this.banners')
      });
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;

        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);

      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
  },
  computed: {
    // 滚动过渡样式
    transitionStyle() {
      return `transform ${this.transitionDuration} linear`;
    }
  },
  mounted() {
    this.startAnimation();

  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getAddress()
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 13vw;
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}

.container {
  width: 100%;
  height: fit-content;
  min-height: 100dvh;
  background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100%;
}

.title {
  font-size: 4vw;
  width: 100%;
  padding: 3vw 2vw 2vw 2vw;
  text-align: center;
  font-weight: bold;
}

.header_content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;

  .img {
    height: 80px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.t-box {
  width: 100%;
  padding: 15px 10px 10px 10px;
}

.t-box .p {
  font-size: 28px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  .btns {
    width: 100%;
    height: fit-content;
    padding: 10px 20px;
    background: linear-gradient(30deg, #7d76ef, #d63f8c);
    color: #fff;
    font-size: 24px;
    border-radius: 30px;
    text-align: center;
    .icon-youjiantou1 {
      font-size: 20px !important;
    }
  }
  .left,.right {
    display: flex;
    align-items: center;
    .iconfont {
      font-size: 32px;
    }

  }
  .quan {
    margin-right: 6px;
    display: block;
    width: 42px;
    height: 42px;
    background: #ebcaaf;
    border-radius: 50%;
  }

  
}
.zan {
    margin-left: auto;
    display: flex;
    align-items: center;
    position: absolute;
    left: 15px;
    top: 15px;
    background: #fff;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    justify-content: center;
    .aixin {
      display: block;
      width: 34px;
      height: 34px;
    }
  }

.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}

.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}

.gdgride {
  width: 345px;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 24px;
}

.gdgride .icon {
  position: absolute;
  z-index: 9;
  background: #D86C98;
  background: linear-gradient(46deg, rgba(216, 108, 152, 1) 0%, rgba(216, 59, 134, 1) 100%);
  color: #ffffff;
  width: 140px;
  height: fit-content;
  font-size: 3vw;
  top: 0px;
  right: 0px;
  padding: 10px;
  display: flex;
  align-items: center;
  border-radius: 0px 0px 0px 15px;
  justify-content: center;
}

.address-box {
  width: 94%;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 135px;
  left: 50%;
  transform: translateX(-50%);

  .address {
    width: 70%;
    display: flex;
    align-items: center;

    .dingwei {
      display: block;
      width: 28px;
      height: 28px;
      margin-right: 5px;
      background: url('/img/dw.png') no-repeat center center / 100%;
    }

    span {
      width: 100%;
      font-size: 25px;
      color: #fff;
      font-weight: bold;
    }
  }

  .btn {
    display: block;
    width: flex;
    font-size: 24px;
    padding: 5px 15px;
    border-radius: 30px;
    color: #fff;
    border: 1px solid #fff;
    white-space: nowrap;
  }

}

.van-image {
  position: relative;
  display: block;
  width: 100%;
  height: 350px;
  border-radius: 15px;
  overflow: hidden;
}

.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}

.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}

.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}

.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}

.top {
  display: flex;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}

.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}

.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}

.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}

.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}

.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}


.scroll-list-container {
  width: 100%;
  height: 1260px;
  /* 容器高度等于单个列表项高度，只显示一项 */
  overflow: hidden;
  /* 隐藏超出容器的内容 */
  position: relative;
  border: 1px solid #eee;
  /* 可选：方便查看容器范围 */
  padding-top: 20px;
}

.scroll-wrap {
  position: absolute;
  width: 100%;
  /* 过渡动画由computed的transitionStyle控制 */
}

.scroll-item {
  height: 60px;
  /* 列表项高度，需与容器高度一致 */
  line-height: 60px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}
.tab-scroll-wrap {
  width: 100%; 
  // background: #ffffff;
}

.tab-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px 12px;
  gap: 8px;
  /* 隐藏滚动条 firefox */
  scrollbar-width: none;
}

/* 隐藏滚动条 chrome */
.tab-scroll::-webkit-scrollbar {
  display: none;
}

.tab-item {
  flex-shrink: 0;
  padding: 12px 18px;
  font-size: 28px;
  white-space: nowrap;
  border-radius: 20px;
  // background: #f2f3f5;
  color: #222222;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-item.active {
  background:linear-gradient(30deg, #7d76ef, #d63f8c);
  color: #fff;
}
</style>
